export type TagActiveStateListener = (tag: string, selected: boolean) => void;
export type NamedTagGroup = { name: string; tags: string[] };

export class AppState {
	readonly groups: NamedTagGroup[];

	private readonly selectedTagsSet: Set<string> = new Set<string>();
	private listeners: TagActiveStateListener[] = [];
	private tagsIndex = new Set<string>();

	constructor(groups: NamedTagGroup[]) {
		this.groups = groups;
		this.indexAllTags(this.groups);
	}

	static createEmpty(): AppState {
		return new AppState([]);
	}

	private indexAllTags(groupsToIndex: NamedTagGroup[]) {
		groupsToIndex.forEach(group =>
			group.tags.forEach(tag => this.tagsIndex.add(tag))
		);
	}

	setTagSelection(tag: string, state: boolean): void {
		if (state) {
			if (this.tagsIndex.has(tag)) {
				this.selectedTagsSet.add(tag);
			}
		} else {
			this.selectedTagsSet.delete(tag);
		}
		this.notifyTagSelectionChange(tag, state);
	}

	getTagSelection(tag: string): boolean {
		return this.selectedTagsSet.has(tag);
	}

	get selectedTags(): string[] {
		return [...this.selectedTagsSet.values()];
	}

	get selectedTagCount(): number {
		return this.selectedTagsSet.size;
	}

	addListener(listener: TagActiveStateListener): void {
		this.listeners.push(listener);
	}

	removeListener(listener: TagActiveStateListener): void {
		const index = this.listeners.indexOf(listener);
		if (index > -1) {
			this.listeners.splice(index, 1);
		}
	}

	private notifyTagSelectionChange(tag: string, state: boolean) {
		for (let listener of this.listeners) {
			listener(tag, state);
		}
	}
}
